import React, { useId, useState } from 'react';
import { getPlatformLogoUrl } from '../RedirectUrl';
import './TradingLoader.scss';

export default function TradingLoader({ size = 64, label = 'Loading', className = '' }) {
  const id = useId().replace(/:/g, '');
  const brandLogo = getPlatformLogoUrl();
  const [loadedLogo, setLoadedLogo] = useState('');
  const [failedLogo, setFailedLogo] = useState('');
  const ready = loadedLogo === brandLogo;
  const failed = failedLogo === brandLogo;
  return (
    <span className={`trading-loader ${className}`} role="status" aria-label={label}
      style={{ width: size * 2.75, height: size }}>
      <svg viewBox="0 0 176 64" width="100%" height="100%" aria-hidden="true">
        <defs>
          <mask id={`${id}-logo`} maskUnits="userSpaceOnUse" x="0" y="0" width="176" height="56" style={{ maskType: 'alpha' }}>
            <image key={brandLogo} href={brandLogo} width="176" height="56" preserveAspectRatio="xMidYMid meet"
              onLoad={() => setLoadedLogo(brandLogo)} onError={() => setFailedLogo(brandLogo)} />
          </mask>
          <clipPath id={`${id}-rail`}><rect x="21" y="61" width="134" height="2" rx="1" /></clipPath>
          <linearGradient id={`${id}-shine`}>
            <stop offset="0" stopColor="currentColor" stopOpacity="0" />
            <stop offset=".55" stopColor="currentColor" stopOpacity=".65" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <linearGradient id={`${id}-accent`}>
            <stop offset="0" stopColor="var(--buy-color, #00c878)" stopOpacity="0" />
            <stop offset=".6" stopColor="var(--buy-color, #00c878)" stopOpacity=".85" />
            <stop offset="1" stopColor="var(--buy-color, #00c878)" stopOpacity="0" />
          </linearGradient>
        </defs>
        {(ready || failed) && <g>
          {ready ? <g mask={`url(#${id}-logo)`}>
            <rect width="176" height="56" fill="currentColor" opacity=".38" />
            <rect className="trading-loader__sweep" x="-84" width="84" height="56" fill={`url(#${id}-accent)`} />
          </g> : <g fill="currentColor" opacity=".38">
            <rect x="65" y="25" width="8" height="18" rx="2" />
            <rect x="84" y="17" width="8" height="26" rx="2" />
            <rect x="103" y="9" width="8" height="34" rx="2" />
          </g>}
          <rect x="21" y="61" width="134" height="2" rx="1" fill="var(--buy-color, #00c878)" opacity=".16" />
          <g clipPath={`url(#${id}-rail)`}>
            <rect className="trading-loader__sweep" x="-84" y="61" width="84" height="2" fill={`url(#${id}-accent)`} />
          </g>
        </g>}
      </svg>
    </span>
  );
}
